export default "__VITE_ASSET__BgiZB4jP__"